import {ref} from "vue";
import {KnowledgeAppraisalAnswers} from "@/medication-checkup/interfaces/knowledge-appraisal";

/**
 * The appraisal a closing asks while live — satisfactory by default — and
 * what its action submits: the reason only for a level judged
 * unsatisfactory, a blank one as nothing.
 */
export function useKnowledgeAppraisal() {
    const appraisal = ref<KnowledgeAppraisalAnswers>({knowledgeable: true, knowledge_gap: ''});

    const submitted = () => ({
        knowledgeable: appraisal.value.knowledgeable,
        knowledge_gap: appraisal.value.knowledgeable ? null : appraisal.value.knowledge_gap.trim() || null,
    });

    return {appraisal, submitted};
}
